import { Box, Button } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

const LoginBottomLinks: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        marginTop: '20px',
        textAlign: 'center',
        justifyContent: 'center',
        gap: 2,
      }}
    >
      <Button sx={{ textTransform: 'none' }}>
        <Link to="/newaccount">Create New Account</Link>
      </Button>

      <Button sx={{ textTransform: 'none' }}>
        <Link to="/resetpassword">Reset Password</Link>
      </Button>
    </Box>
  );
};

export default LoginBottomLinks;
